import { CopyButton } from '@/shared/components/CopyButton';

import { EDITOR_COPY } from '../copy';

/**
 * A setup to paste: the text as it must be typed, and the app's one copy
 * control beside it (spec 236 FR-006). Wraps rather than scrolls, so a phone
 * shows all of it. The control says "Copied" for a moment, names a refused
 * clipboard instead of snapping back to "Copy", and says either outcome to a
 * screen reader.
 */
export function CopyBlock({ text, label }: { text: string; label: string }) {
  return (
    <div className="bg-muted/40 border-border flex items-start gap-2 rounded-md border p-2 ps-3">
      {/* On touch the copy control is 44px tall: 14px above the first line
          centres it on the control, as 4px does on the 32px one. */}
      <pre className="text-foreground min-w-0 flex-1 py-1 pointer-coarse:py-3.5 font-mono text-xs [overflow-wrap:anywhere] whitespace-pre-wrap">
        {text}
      </pre>
      <CopyButton
        text={text}
        label={EDITOR_COPY.copy(label)}
        copiedLabel={EDITOR_COPY.copied(label)}
        failedLabel={EDITOR_COPY.copyFailed(label)}
        className="shrink-0"
        announce
      />
    </div>
  );
}
